import React from 'react';
import styles from './tv-guide.module.scss';

import testIds from '@smart-tv/e2e/shared/variables';



interface Props {
  offsetX?: number;
  height?: number;
}

const TvGuideLiveMarker: React.FC<Props> = (props: Props) => {
  const { offsetX, height } = props;

  return (
    <div className={styles['tv-guide-live-marker']}
      style={{
        '--live-marker-offset-x': `${offsetX}px`,
        '--live-marker-height': `${height}px`
      } as React.CSSProperties}
      data-testid={testIds.tvGuide.timeline.liveMarker}
    />
  );
};

export default React.memo(TvGuideLiveMarker);
